module.exports = __webpack_public_path__ + "static/img/img_5.5fc50e98.jpg";